// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"09410de7","453":"d1d964bc","455":"1749315b","977":"e456534c"}[chunkId] + ".chunk.js";
};